import { selectCookieConsentCountries } from 'root-redux/selects/common'
import {
  selectCookieConsent,
  selectHasCookieForUSUser,
  selectUserCountryCode,
} from 'root-redux/selects/user'

import { useBulkSelector } from 'hooks/common/useBulkSelector'

import { CookieConsentOption } from 'root-constants/common'

const useSelectors = () =>
  useBulkSelector({
    userCountryCode: selectUserCountryCode,
    cookieConsent: selectCookieConsent,
    cookieConsentCountries: selectCookieConsentCountries,
    hasCookieForUS: selectHasCookieForUSUser,
  })

export const useCookieConsentAnswer = () => {
  const {
    userCountryCode,
    cookieConsent,
    cookieConsentCountries,
    hasCookieForUS,
  } = useSelectors()

  const isEUUser = cookieConsentCountries.includes(
    userCountryCode.toUpperCase(),
  )

  const isPermissionNeeded = isEUUser || hasCookieForUS

  const {
    hasAdvertisingAndTargetingCookie,
    hasFunctionalCookie,
    hasAnalyticsAndPerformanceCookie,
  } = {
    hasAdvertisingAndTargetingCookie: (cookieConsent || []).includes(
      CookieConsentOption.ADVERTISING_AND_TARGETING,
    ),
    hasFunctionalCookie: (cookieConsent || []).includes(
      CookieConsentOption.FUNCTIONAL_COOKIES,
    ),
    hasAnalyticsAndPerformanceCookie: (cookieConsent || []).includes(
      CookieConsentOption.ANALYTICS_AND_PERFORMANCE,
    ),
  }

  const isPersonalDataAllowed =
    (isPermissionNeeded && hasFunctionalCookie) || !isPermissionNeeded

  return {
    isEUUser,
    hasAdvertisingAndTargetingCookie,
    hasFunctionalCookie,
    hasAnalyticsAndPerformanceCookie,
    cookieConsent,
    isPersonalDataAllowed,
    isPermissionNeeded,
  }
}
